import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "flex bg-black items-center flex-col justify-between"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h4", { class: "p-4 text-white text-3xl font-bold" }, "7-Day Forecast", -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)
const _hoisted_4 = { class: "flex mt-8 flex-wrap justify-center md:justify-between items-center p-4 space-x-4 md:space-x-0" }
const _hoisted_5 = { class: "flex flex-col text-black space-y-10" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("p", { class: "text-xl md:text-2xl font-bold" }, "Date", -1)
const _hoisted_7 = { class: "text-5xl md:text-6xl font-san-narrow" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("sup", { class: "text-md md:text-xl relative -top-8" }, "o", -1)
const _hoisted_9 = /*#__PURE__*/_createTextVNode(" Min Temp: ")
const _hoisted_10 = { class: "italic" }
const _hoisted_11 = /*#__PURE__*/_createTextVNode(" Max temp: ")
const _hoisted_12 = { class: "italic" }
const _hoisted_13 = /*#__PURE__*/_createTextVNode(" Dewpt: ")
const _hoisted_14 = { class: "italic" }
const _hoisted_15 = { class: "flex flex-col text-black space-y-10" }
const _hoisted_16 = { class: "text-xl font-bold" }
const _hoisted_17 = ["src"]
const _hoisted_18 = { class: "text-md italic" }
const _hoisted_19 = { class: "text-md italic" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.weatherStore.fiverDayForecast.length > 1)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _hoisted_2,
        _hoisted_3,
        _createElementVNode("div", _hoisted_4, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.weatherStore.fiverDayForecast, (day, index) => {
            return (_openBlock(), _createElementBlock("a", {
              class: "w-72 h-72 p-4 rounded-xl ease-in duration-300 md:h-80 md:w-80 bg-sky-bluish flex justify-between items-center mt-6",
              href: "#",
              key: index
            }, [
              _createElementVNode("div", _hoisted_5, [
                _hoisted_6,
                _createElementVNode("p", _hoisted_7, [
                  _createTextVNode(_toDisplayString(day.temp), 1),
                  _hoisted_8
                ]),
                _createElementVNode("div", null, [
                  _createElementVNode("p", null, [
                    _hoisted_9,
                    _createElementVNode("span", _hoisted_10, _toDisplayString(day.min_temp), 1)
                  ]),
                  _createElementVNode("p", null, [
                    _hoisted_11,
                    _createElementVNode("span", _hoisted_12, _toDisplayString(day.max_temp), 1)
                  ]),
                  _createElementVNode("p", null, [
                    _hoisted_13,
                    _createElementVNode("span", _hoisted_14, _toDisplayString(day.dewpt), 1)
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_15, [
                _createElementVNode("p", _hoisted_16, _toDisplayString(_ctx.getDay(day.valid_date)), 1),
                _createElementVNode("img", {
                  src: _ctx.getIcon(day.weather.description),
                  class: "w-20",
                  alt: "Weather Icon"
                }, null, 8, _hoisted_17),
                _createElementVNode("div", null, [
                  _createElementVNode("p", _hoisted_18, _toDisplayString(day.weather.description), 1),
                  _createElementVNode("p", _hoisted_19, "wind_spd: " + _toDisplayString(day.wind_spd), 1)
                ])
              ])
            ]))
          }), 128))
        ])
      ]))
    : _createCommentVNode("", true)
}